// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1Ou78","content":"GlobalSearch_content__33WFT"};